"use client";

import { c as _c } from "react/compiler-runtime";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import React, { useState } from "react";
import UserPageHeaderEditName from "./UserPageHeaderEditName";
export default function UserPageHeaderNameWrapper(t0) {
  const $ = _c(16);
  const {
    profile,
    canEdit,
    children
  } = t0;
  const [isEditNameOpen, setIsEditNameOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsEditNameOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = !canEdit;
  const t3 = `${canEdit ? "hover:tw-text-iron-400" : ""} tw-group tw-bg-transparent tw-border-none tw-m-0 tw-p-0 tw-relative tw-transition tw-duration-300 tw-ease-out`;
  let t4;
  if ($[1] !== canEdit) {
    t4 = canEdit && <div className="group-hover:tw-block tw-hidden tw-absolute tw-inset-0 tw-text-iron-400"><div className="tw-absolute tw-top-1.5 -tw-left-5 tw-z-10"><PencilIcon /></div></div>;
    $[1] = canEdit;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <button onClick={t1} disabled={t2} aria-label="Edit profile name" className={t3}>{children}{t4}</button>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isEditNameOpen || $[9] !== profile) {
    t6 = isEditNameOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageHeaderEditName profile={profile} onClose={() => setIsEditNameOpen(false)} /></CommonAnimationOpacity>;
    $[8] = isEditNameOpen;
    $[9] = profile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <CommonAnimationWrapper mode="sync" initial={true}>{t6}</CommonAnimationWrapper>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}